import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _get from 'lodash/get';
export function getPageAttributes(dataLayer) {
  var _dataLayer$vehicle;
  // eslint-disable-next-line camelcase
  var _get2 = _get(dataLayer, 'page', {}),
    pg = _get2.pg,
    brandPg = _get2.brandPg,
    testName = _get2.testName,
    experimentBoosts = _get2.experimentBoosts,
    pixallPageInstanceId = _get2.pixallPageInstanceId;
  return {
    abTestId: testName,
    experimental: {
      boost: experimentBoosts
    },
    label: brandPg || pg,
    pageInstanceId: pixallPageInstanceId,
    pageId: pg === 'error' ? pg : brandPg || pg,
    vehicleType: dataLayer == null ? void 0 : (_dataLayer$vehicle = dataLayer.vehicle) == null ? void 0 : _dataLayer$vehicle.type
  };
}
export function getPageId(dataLayer) {
  return _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
}
export function getConsumerMetadata(_x) {
  return _getConsumerMetadata.apply(this, arguments);
}
function _getConsumerMetadata() {
  _getConsumerMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dataLayer) {
    var consumerMetadata;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof (dataLayer == null ? void 0 : dataLayer.consumerMetadata) === 'function')) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return dataLayer.consumerMetadata();
        case 3:
          _context.t0 = _context.sent;
          _context.next = 7;
          break;
        case 6:
          _context.t0 = {};
        case 7:
          consumerMetadata = _context.t0;
          return _context.abrupt("return", {
            consumerMetadata: consumerMetadata
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getConsumerMetadata.apply(this, arguments);
}
export default {
  getPageAttributes: getPageAttributes,
  getPageId: getPageId,
  getConsumerMetadata: getConsumerMetadata
};